import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id D4CB36CD-4F30-45BE-940D-CC2AFFCA078A
 * name transfer-down
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transfer-down.svg
 * tags
 * - Arrow 
 */
export const TransferDownIcon = createSvgIcon(<><path d="M16,3V5H8V3H16M16,7V9H8V7H16M16,11V13H8V11H16M5,15H19L12,22L5,15Z" /></>, 'TransferDownIcon');
export default TransferDownIcon